
import { mapGetters } from 'vuex'

export default {
  props: {
    links: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters('user', ['hasGroups', 'groups']),
    activeLink() {
      return this.links.find((link) => this.$route.path.includes(link.to))
    },

    permittedLinks() {
      return this.links.filter((link) => this.hasGroups(link.groups))
    },
  },
}
